import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { customDateFormat } from 'helpers/dateFormat';
import checkIcon from 'assets/check_circle_24px.svg';

const CompletedBanner = ({ item, onDismiss }) => {
  const bannerRef = useRef();

  const getMessage = useCallback(() => {
    const cropName = item.otherFields?.cropName || '';
    const yieldName = item.otherFields?.yieldName || '';
    const formattedDate = customDateFormat(
      item.createdAt,
      'MMM d, yyyy hh:mma'
    );

    if (item.actionType === 'DELETE') {
      return `Successfully deleted ${cropName} load ${yieldName} (submitted ${formattedDate}).`;
    }

    if (item.actionType === 'EDIT') {
      return `Successfully edited ${cropName} load ${yieldName} (submitted ${formattedDate}).`;
    }

    return `Successfully saved the ${cropName} loads that were created on ${formattedDate}.`;
  }, [item]);

  const handleDismiss = e => {
    e.preventDefault();
    e.stopPropagation();
    e.target.blur();
    bannerRef.current.classList.add('completed-banner-dismiss-animation');
    bannerRef.current.addEventListener('animationend', onDismiss, {
      once: true
    });
  };

  return (
    <div
      ref={bannerRef}
      key={`completed-${item.id}`}
      className="text-sm bg-green-50 flex flex-row items-center justify-between banner-container"
    >
      <p className="inline-flex items-center">
        <img
          alt="success"
          src={checkIcon}
          className="
            mr-2 h-24px w-24px
          "
        />
        {getMessage()}
      </p>
      <button
        type="button"
        className="btn-action-task"
        data-testid="dismiss-button"
        onClick={handleDismiss}
      >
        Dismiss
      </button>
    </div>
  );
};

CompletedBanner.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    createdAt: PropTypes.string,
    cropSeasonId: PropTypes.string,
    actionType: PropTypes.oneOf(['ADD', 'DELETE', 'EDIT']),
    otherFields: PropTypes.shape({
      cropName: PropTypes.string,
      yieldName: PropTypes.string
    })
  }).isRequired,
  onDismiss: PropTypes.func.isRequired
};

export default CompletedBanner;
